import(/* webpackMode: "eager", webpackExports: ["ClientAdUnit"] */ "/app/components/ads/ClientAdUnit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/category-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/recommended-games.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RetryButton"] */ "/app/components/retry-button.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.29_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.29_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
